import React from "react";
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { monokaiSublime } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { solarizedLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/hljs';

/* const jsonString = `{
    "name": "John Doe", // Notation example
    "age": 30,
    "occupation": "Software Engineer",
    "address": {
      "street": "123 Main St",
      "city": "Anytown",
      "state": "CA",
      "zip": "12345"
    }
  }`; */

const Helper = (props) => {
    const show = 1
    if (!show) return <></>;
    
    return (
        <>
{/*         <hr></hr>
        <h3 style={{color: "pink"}}>===Helper===</h3>
        <div><pre>{JSON.stringify(props, null, 2) }</pre></div>; */}
        <h3 style={{color: "pink"}}>===Helper===</h3>

        <SyntaxHighlighter language="javascript" style={github}>
        {JSON.stringify(props, null, 2)}
      </SyntaxHighlighter>
        </>
    )
}

export default Helper;